import { prepareCommunityBody } from './utils'
import { api } from '@/app'
import { AchievementLevel, CommunityFeed, Post, Prompt } from '@/types'
import { WebInputFile } from '@codeleap/common'
import { AppStatus } from '@/redux'
import { videoCache } from '@/utils/videoCache'
import { queryClient } from '../queryClient'
import { useMutation } from '@tanstack/react-query'
import { createQueryManager, PaginationResponse } from '@codeleap/query'
import { achievementsStore } from '@/stores'

const BASE_URL = 'community/prompt/'

export const promptsManager = createQueryManager({
  name: 'community-prompts',
  queryClient: queryClient.client,
  listLimit: 20,

  async listFn(limit, offset, filters) {
    const response = await api.get<PaginationResponse<Prompt>>(BASE_URL, {
      params: {
        limit,
        offset
      }
    })

    return response.data?.results
  }
})

type PromptContent = {
  id: CommunityFeed['prompt']['id']
  image?: WebInputFile
  description?: string
  video?: WebInputFile
  lesson?: number
}

const answerPrompt = async (params: PromptContent) => {
  const body = await prepareCommunityBody(params)

  const response = await api.post<Post>(`community/prompt/${params.id}/answer/`, body, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })

  const videoPath = params?.video?.preview

  if (videoPath) {
    // Since transcoding hasn't completed yet, we load the local video in the feed
    response.data.video.url = videoPath
    videoCache.set(response.data.feed_item, videoPath)
  }

  achievementsStore.verifyProgress(response?.data?.achievement_progress as any)

  return response.data
}

export function useAnswerPrompt() {
  const mut = useMutation({
    mutationKey: ['communityPrompt'],
    mutationFn: answerPrompt,
    onMutate: () => AppStatus.set('loading'),
    onSettled: () => AppStatus.set('idle')
  })

  return mut
}
